module.exports = __webpack_public_path__ + "static/media/RecomendaParaty.ba445004.jpg";